import queryString from "query-string";
import moment from "moment";
import differenceInDays from "date-fns/differenceInDays";
import { Buffer } from "buffer";

// Icons
import ServiceInfoIcon from "../components/iconComponents/ServiceInfoIcon";
import ServiceInfoWarningIcon from "../components/iconComponents/ServiceInfoWarningIcon";

// Themes
import theme from "../themes/mdc-theme";

// Constants
import RolePermissions from "../constants/RolePermissions";
import { userRoles, VWAG_GROUP } from "../constants/userConstants";
import { COMPONENT_IDS } from "../constants/RolePermissions";

// Valid Email
export const validateEmail = (email) => {
  const emailCheck =
    /^(?=.{1,200}$)(?!.*\.\.)(?!.*@.*@)[a-zA-Z0-9]+(?:[._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[._-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,10}$/i;

  if (!emailCheck.test(email)) {
    return false;
  }

  return true;
};

// Format the Date
export const formatDate = (date) => {
  if (!date) {
    return "";
  }

  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join(".");
};

// DB Format the Date
export const dbFormatDate = (date, defaultFormatSplitter = "-") => {
  if (!date) {
    return "";
  }

  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join(defaultFormatSplitter);
};

// Get the url parameter
export const getUrlParams = (url) => {
  let params = queryString.parse(url);
  return params;
};

// Get the Between Two Dates
export const getDateDifference = (startDate, endDate) => {
  return differenceInDays(new Date(endDate), new Date(startDate));
};

// Convert Month and Year
export const getFullDate = (monthYear) => {
  if (!monthYear) {
    return "";
  }

  const splittedMonth = monthYear.slice(0, 2);
  const splittedYear = monthYear.slice(2, 6);

  const date = new Date();

  const day = date.getDate();

  return `${splittedYear}-${splittedMonth}-${day}`;
};

// DB Month and year Format
export const getDBMonthYearFormat = (date) => {
  if (!date) {
    return "";
  }

  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;

  return [month, year].join("");
};

// Full Month Day and Year format
export const getMonthDayYearFullDate = (monthYear) => {
  if (!monthYear) {
    return "";
  }

  const splittedMonth = monthYear?.slice(0, 2);
  const splittedYear = monthYear?.slice(2, 6);

  const date = new Date();

  const day = date.getDate();

  return `${splittedMonth}-${day}-${splittedYear}`;
};

//This Function will return promise with the value of base 64 encoded string
export const getBase64String = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const getBlobDataURL = (base64fileString, fileType) => {
  if (base64fileString && fileType) {
    const normalizedFileType = String(fileType).toLowerCase();
    const imageMimeTypes = {
      svg: "image/svg+xml",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      webp: "image/webp",
      gif: "image/gif",
    };

    if (imageMimeTypes[normalizedFileType]) {
      return `data:${imageMimeTypes[normalizedFileType]};base64,${base64fileString}`;
    }

    const base64DecodedData = Buffer.from(base64fileString, "base64");
    const documentBlobData = new Blob([base64DecodedData]);
    const documentBlobDataURL = URL.createObjectURL(documentBlobData);
    return documentBlobDataURL;
  } else return null;
};
export const statusMessagesColorScheme = {
  //For Error/Urgent Message
  Dringend: {
    color: theme.palette.MDCColors.color36,
    textColor: theme.palette.MDCColors.white,
    icon: <ServiceInfoWarningIcon />,
  },
  //For Warning Message
  Warnung: {
    color: theme.palette.MDCColors.color37,
    textColor: theme.palette.MDCColors.black,
    icon: <ServiceInfoWarningIcon />,
  },
  // For Information Message
  Information: {
    color: theme.palette.MDCColors.color23,
    textColor: theme.palette.MDCColors.black,
    icon: <ServiceInfoIcon />,
  },
};

export const getCurrentYear = () => {
  return new Date().getFullYear();
};
export const getCurrentMonthIndex = () => {
  return new Date().getMonth();
};

/**
 * Get Years Options
 *
 * @returns
 */
export const getYearOptions = () => {
  const currentYear = new Date().getFullYear();

  let yearOptions = [];
  for (let i = 2020; i <= currentYear; i++) {
    yearOptions.push({
      label: i,
      value: i,
    });
  }

  return yearOptions;
};

/**
 * Formatted Date
 *
 * @param {*} date
 * @returns
 */
export const formattedDate = (date) => {
  if (!date) {
    return "";
  }

  return moment(date).format("DD.MM.YYYY");
};

/**
 * Formatted Month And Year
 *
 * @param {*} date
 * @returns
 */
export const formattedMonthAndYear = (date) => {
  if (!date) {
    return "";
  }

  return moment(date).format("MMMM YYYY");
};

export function removeNullAndEmpty(obj) {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === "") {
      delete obj[key];
    } else if (typeof obj[key] === "object") {
      removeNullAndEmpty(obj[key]); // Recursive call for nested objects
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
  return obj;
}

// Format date string in to DD.MM.YYYY
export function convertStringToDate(dateString) {
  return moment(dateString.split("+")[0]).format("DD.MM.YYYY");
}

// Get File Name From Http Response
export function getFileNameFromHttpResponse(httpResponse) {
  return (httpResponse && httpResponse?.headers["x-suggested-filename"]) || "";
}

// Has Role Permissions
export const hasRolePermissions = (page, action) => {
  const userDetails = JSON.parse(localStorage.getItem("user"));

  const userRolesArray = userRoles?.reduce((acc, roleDetails) => {
    acc.push(
      userDetails?.roles?.includes(roleDetails) &&
        RolePermissions[roleDetails]?.[page]?.includes(action)
    );
    return acc;
  }, []);

  return userRolesArray.some((value) => value === true);
};

export const getPermibasedonTab = (tabNum, subTab) => {
  let permibasedonTab = false;
  if (tabNum === 0) {
    permibasedonTab = hasRolePermissions(COMPONENT_IDS.PROFILE, "update");
  } else if (tabNum === 1) {
    if (subTab === 0) {
      permibasedonTab = hasRolePermissions(COMPONENT_IDS.GKS, "update");
    } else if (subTab === 1) {
      permibasedonTab = hasRolePermissions(COMPONENT_IDS.FORDERUNG, "update");
    } else if (subTab === 2) {
      permibasedonTab = hasRolePermissions(
        COMPONENT_IDS.DATEN_UR_Rechnungsabrechnung,
        "update"
      );
    }
  } else if (tabNum === 2) {
    permibasedonTab = hasRolePermissions(COMPONENT_IDS.BETRIEBE, "update");
  } else if (tabNum === 3) {
    if (subTab === 0) {
      permibasedonTab = hasRolePermissions(COMPONENT_IDS.MITARBEITER, "update");
    } else if (subTab === 1) {
      permibasedonTab = hasRolePermissions(
        COMPONENT_IDS.MITARBEITERVERWALTUNG,
        "update"
      );
    }
  } else if (tabNum === 4) {
    permibasedonTab = hasRolePermissions(COMPONENT_IDS.SETTINGS, "update");
  }
  return permibasedonTab;
};

let activeUser = JSON.parse(localStorage.getItem("activeUser"));
export const getActiveUserTenantAlias = () => {
  //returning tenant alias name
  return activeUser?.value;
};

export const getActiveUserGroupId = () => {
  return activeUser?.groupID;
};

// Encode search value
export const encodeSearchValue = (value) => {
  if (typeof value === "object") {
    return encodeURIComponent(JSON.stringify(value));
  }

  return encodeURIComponent(String(value));
};

// Get Values from key with Objects
export const getValuesFromKeyWithObjects = (key, data) => {
  return data.find((dataDetails) => dataDetails?.key === key);
};

// Is VWAG group
export const isVWAGGroup = () => {
  const activeUserDetails = JSON.parse(localStorage.getItem("activeUser"));

  return activeUserDetails?.groupID === VWAG_GROUP;
};

// truncated Text By Character Length
export const truncatedTextByLength = (text, maxLength = 250) => {
  const truncated =
    text?.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  return truncated;
};

// Formatted Date
export const getFormattedDate = (date, format = "DD.MM.YYYY") => {
  return moment(date).format(format);
};

export const convertFormattedDateRangePickerFilter = (startDate, endDate) => {
  const filterStartDate = startDate ? formatDate(startDate) : "";

  const filterEndDate = endDate ? formatDate(endDate) : "";

  const isSingleDate = getDateDifference(
    dbFormatDate(startDate),
    dbFormatDate(endDate)
  );

  const covertedDateFormat =
    isSingleDate === 0
      ? filterStartDate
      : `${filterStartDate ? filterStartDate : ""} ${
          filterEndDate ? `- ${filterEndDate}` : ""
        }`;

  return covertedDateFormat;
};

// Get Manual Request Form Objects Difference starts

function normalizeValue(val) {
  if (typeof val === "string") {
    if (val.toLowerCase() === "true") return true;
    if (val.toLowerCase() === "false") return false;
  }
  return val;
}

export function getObjectDifferenceArrayValues(oldArr, newArr) {
  const diff = [];

  for (const newItem of newArr) {
    const oldItem = oldArr.find((o) => o.id === newItem.id);

    if (!oldItem) {
      // Skip the item entirely if no match is found
      continue;
    }

    if (Array.isArray(newItem.value) && Array.isArray(oldItem.value)) {
      const nestedDiff = getObjectDifferenceArrayValues(
        oldItem.value,
        newItem.value
      );
      if (nestedDiff.length > 0) {
        diff.push({ id: newItem.id, value: nestedDiff });
      }
    } else {
      const oldVal = normalizeValue(oldItem.value);
      const newVal = normalizeValue(newItem.value);

      // Skip if both values are falsy
      if (!oldVal && !newVal) continue;

      if (oldVal !== newVal) {
        diff.push(newItem);
      }
    }
  }

  return diff;
}

// Get Manual Request Form Objects Difference Ends

// Convert Base64 into Blob URL
export function convertBase64StringToBlobURL(base64File, type = "") {
  if (!base64File) return null;

  const normalizedType = String(type).toLowerCase();
  const inferMimeTypeFromBase64 = (base64Content) => {
    if (base64Content.startsWith("iVBORw0KGgo")) return "image/png";
    if (base64Content.startsWith("/9j/")) return "image/jpeg";
    if (base64Content.startsWith("R0lGOD")) return "image/gif";
    if (base64Content.startsWith("UklGR")) return "image/webp";
    if (
      base64Content.startsWith("PHN2Zy") ||
      base64Content.startsWith("PD94bWwg")
    ) {
      return "image/svg+xml";
    }
    if (base64Content.startsWith("JVBERi0")) return "application/pdf";
    return "application/octet-stream";
  };

  const mimeType = normalizedType || inferMimeTypeFromBase64(base64File);

  if (mimeType.startsWith("image/")) {
    return `data:${mimeType};base64,${base64File}`;
  }

  const byteCharacters = atob(base64File);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const file = new Blob([byteArray], { type: mimeType });
  const fileURL = URL.createObjectURL(file);
  return fileURL;
}

// Download file with Blob URL
export function downloadFileWithBlobURL(blobURL, fileName) {
  if (!blobURL || !fileName) return;

  const downloadLink = document.createElement("a");
  downloadLink.href = blobURL;
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export function downloadPdfFromBase64(
  base64String,
  fileName,
  allowEmpty = false
) {
  if (!fileName || (!base64String && !allowEmpty)) return;

  const blobURL = base64String
    ? convertBase64StringToBlobURL(base64String, "application/pdf")
    : URL.createObjectURL(new Blob([], { type: "application/pdf" }));

  downloadFileWithBlobURL(blobURL, fileName);

  // Revoke only object URLs created in this function.
  if (!base64String && allowEmpty) {
    setTimeout(() => URL.revokeObjectURL(blobURL), 0);
  }
}

export function getFileMIMEType(filename) {
  const extension = filename.split(".").pop().toLowerCase();

  const fileTypes = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    txt: "text/plain",
    json: "application/json",
    csv: "text/csv",
  };

  return fileTypes[extension] || "application/octet-stream";
}

export function getFileExtension(filename) {
  return filename.split(".").pop().toLowerCase();
}
